/**
 * Created by RamKumar on 12/16/16.
 */

(function(Backbone, EG) {
  'use strict';

  var API, validationRulesCache, FORM_CLASSES;

  API = {
    validationRules: '/users/validation-rules',
  };

  FORM_CLASSES = {
    invalid: 'invalid',
    hidden: 'hidden',
    inputGroupClass: '.input-group',
    inputMessageClass: '.input-message',
  };

  validationRulesCache = new EG.Users.Libs.LocalCache({
    key: 'validationRules',
  });

  function ValidationBuilder() {}

  _.extend(Backbone.Validation.callbacks, {
    valid: function(view, attr, selector) {
      var $el, $group;

      $el = view.$el.find('[' + selector + '="' + attr + '"]');
      $group = $el.closest(FORM_CLASSES.inputGroupClass);

      $group.removeClass(FORM_CLASSES.invalid);
      $group
        .find(FORM_CLASSES.inputMessageClass)
        .html('')
        .addClass(FORM_CLASSES.hidden);
    },
    invalid: function(view, attr, error, selector) {
      var $el, $group, validationRules, validationValue;
      $el = view.$el.find('[' + selector + '="' + attr + '"]');
      $group = $el.closest(FORM_CLASSES.inputGroupClass);

      validationRules = view.model.validation[attr];
      for(var i in validationRules) {
        if (validationRules[i].msg === error[0]) {
          validationValue = validationRules[i].customVal;
        }
      }

      $group.addClass(FORM_CLASSES.invalid);
      $group
        .find(FORM_CLASSES.inputMessageClass)
        .html(I18n.t(error[0], {arg0: validationValue}))
        .removeClass(FORM_CLASSES.hidden);
    },
  });

  Backbone.Validation.configure({
    selector: 'id',
  });

  ValidationBuilder.prototype.getValidationRulesByUserAndCompany = function(userId, companyId) {
    var defer = $.Deferred(),
      self = this;
    $.ajax({
      method: 'GET',
      url: API.validationRules,
      data: {
        user_id: userId,
        company_id: companyId,
      },
      dataType: 'json',
    })
      .done(function(response) {
        var parsedRules = self._parseValidationRules(response);
        defer.resolve(parsedRules);
      })
      .fail(function(error) {
        defer.reject(error);
      });

    return defer.promise();
  };

  ValidationBuilder.prototype.fetchValidationRulesForUserAndCompany = function(userId, companyId) {
    var validationRules, defer;

    if (!userId) {
      throw new Error('To fetch validation rules it requires User ID');
      return;
    }

    if (!companyId) {
      throw new Error('To fetch validation rules it requires Company ID');
      return;
    }

    defer = $.Deferred();

    validationRules = validationRulesCache.get([userId, companyId]);

    if (!_.isEmpty(validationRules) && !_.isUndefined(validationRules)) {
      defer.resolve(validationRules);
    } else {
      this.getValidationRulesByUserAndCompany(userId, companyId).then(
        function(rules) {
          validationRulesCache.store([userId, companyId], rules);
          defer.resolve(rules);
        },
        function(error) {
          defer.reject(error);
        }
      );
    }

    return defer.promise();
  };

  ValidationBuilder.prototype._parseValidationRules = function(validationRules) {
    var recurseRules,
      rules = _.clone(validationRules);

    recurseRules = function(_rules, field) {
      _.each(_rules, function(_rule, _key) {
        if (_.isObject(_rule) && !_.isArray(_rule)) {
          _rules[_key] = recurseRules(_rule, _key);
        } else {
          if (_.isArray(_rule)) {
            var _validations = [];
            _.each(_rule, function(_validationRule) {
              var _validation = {};

              if (_validationRule.value && _validationRule.frontend !== false) {
                _validation[_validationRule.type] = _validationRule.value;
                _validation['customVal'] = _validationRule.value;
                _validation['msg'] = _validationRule.messageKey;

                _validations.push(_validation);
              }
            });

            if (!_.find(_validations, 'required')) {
              _validations.unshift({
                required: false,
                msg: 'required_field',
              });
            }

            var deps = _.find(_rule, 'deps');

            if (deps) {
              var req;

              deps = deps.deps;

              req = _.find(_validations, 'required') || _.find(_validations, { required: false });

              req.required = function(val, attr, computedValue) {
                var valDeps = [],
                  nestedDep,
                  _computedValue,
                  _temp;

                for (var i = 0; i < deps.length; i++) {
                  nestedDep = deps[i].split('.');
                  if (nestedDep.length > 1) {
                    _temp = nestedDep.join('"]["');
                    _temp = '["' + _temp + '"]';
                    _computedValue =
                      '(computedValue' + _temp + ' !== undefined) && (computedValue' + _temp + ' !== "")';
                  } else {
                    _computedValue =
                      '(computedValue["' +
                      deps[i] +
                      '"] !== undefined) && (computedValue["' +
                      deps[i] +
                      '"] !==' +
                      ' "") ';
                  }
                  valDeps.push(_computedValue);
                }

                return eval(valDeps.join('|| '));
              };
            }

            _rules[_key] = _validations;
          }
        }
      });

      return _rules;
    };

    recurseRules(rules, '');

    return rules;
  };

  ValidationBuilder.prototype.bindValidation = function(properties) {
    this._applyValidationRulesToModel(
      properties.model,
      properties.$view,
      properties.validationConfigCategory,
      properties.userId,
      properties.companyId
    );
  };

  ValidationBuilder.prototype._getValidationRulesByCategoryUserAndCompany = function(categoryName, userId, companyId) {
    var validationRules, categories;

    validationRules = validationRulesCache.get([userId, companyId]) || {};

    categories = categoryName.split(".");
    _.forEach(categories, function (category) {
      validationRules = validationRules[category]
    });

    return validationRules;
  };

  ValidationBuilder.prototype.setValidationRules = function(userId, companyId, rules) {
    var _rules;
    _rules = this._parseValidationRules(rules);
    validationRulesCache.store([userId, companyId], _rules);
  };

  ValidationBuilder.prototype._applyValidationRulesToModel = function(
    model,
    $view,
    validationConfigCategory,
    userId,
    companyId
  ) {
    var modelValidationRules, recurseModel;

    userId = userId || model.getUserId();
    companyId = companyId || EG.Users.Utils.getCompanyId();

    modelValidationRules = this._getValidationRulesByCategoryUserAndCompany(
      validationConfigCategory,
      userId,
      companyId
    );

    recurseModel = function(properties) {
      var validationRule, _model, _validationRuleParent, existingValidation;

      _model = properties.model;
      _validationRuleParent = properties.validationRuleParent;

      existingValidation = _.clone(_model.validation);

      validationRule = _validationRuleParent ? modelValidationRules[_validationRuleParent] : modelValidationRules;

      if (_model instanceof Backbone.Collection && _model.isValidationRequired) {
        if (_model.hasIndividualModelValidations) {
          var _existingValidation;
          _.each(_model.models, function(modelAttributeModel) {
            _existingValidation = _.clone(modelAttributeModel.validation);

            _model.applyValidation(modelAttributeModel, validationRule, {
              onApplied: function(appliedModel, $view) {
                _.each(_existingValidation, function(validation, key) {
                  appliedModel.validation[key] = appliedModel.validation[key]
                    ? appliedModel.validation[key].concat(_existingValidation[key])
                    : appliedModel.validation[key];
                });
                Backbone.Validation.bind({
                  model: appliedModel,
                  $el: $view,
                });
              },
            });
          });
        } else {
          _.each(_model.models, function(_modelAttributeModel) {
            recurseModel({
              model: _modelAttributeModel,
              validationRuleParent: _model.validationRuleConfig,
            });
          });
        }
      }

      _.each(_model.toJSON(), function(modelAttributeValue, modelAttributeKey) {
        if (modelAttributeValue instanceof Backbone.Model) {
          recurseModel({
            model: modelAttributeValue,
            validationRuleParent: modelAttributeValue.validationRuleConfig,
          });
        } else {
          if (_model.hasIndividualValidations) {
            _model.applyValidation(modelAttributeKey, validationRule, {
              onApplied: function(validationRule) {
                if (!validationRule) {
                  return;
                }
                _model.validation[modelAttributeKey] = validationRule;
              },
            });
            return;
          }

          if (!validationRule[modelAttributeKey]) {
            return;
          }

          _model.validation[modelAttributeKey] = validationRule[modelAttributeKey];
        }
      });

      _.each(existingValidation, function(validation, key) {
        if (!_model.validation) {
          return;
        }
        _model.validation[key] = _model.validation[key]
          ? _model.validation[key].concat(existingValidation[key])
          : _model.validation[key];
      });

      Backbone.Validation.bind({
        model: _model,
        $el: $view,
      });
    };

    recurseModel({
      model: model,
      validationRuleParent: model.validationRuleConfig,
    });
  };

  EG.Users.Libs.ValidationBuilder = new ValidationBuilder();
})(Backbone, EG);
